export const defaultTabs = [
  {
    step: 0,
    title: 'Historial crediticio',
    states: [
      'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7',
      'E10', 'E11', 'E12', 'E13', 'E14',
      'E32', 'E33', 'E34', 'E35', 'E36',
      'E40', 'E41', 'E42', 'E43', 'E44'
    ],
  },
  {
    step: 1,
    title: 'Información complementaria',
    states: [
      'E8', 'E9',
      'E15', 'E16',
      'E37', 'E38',
      'E45', 'E46'
    ],
  },
  {
    step: 2,
    title: 'Carga de documentos',
    states: [
      'E18', 'E48'
    ],
  },
  {
    step: 3,
    title: 'Formulario de Solicitud',
    states: ['E20'],
  },
  {
    step: 4,
    title: 'Verificación de identidad',
    states: [
      'E17', 'E31', 'E39', 'E47'
    ],
  },
  {
    step: 5,
    title: 'Estatus Final',
    //states: ['E21', 'E22', 'E23', 'E24', 'E25', 'E26', 'E27', 'E28', 'E29'],
    states: ['E21', 'E22', 'E23', 'E24', 'E25', 'E26', 'E27', 'E28', 'E29', 'E50', 'E49', 'E51'],
    //states B : ['E21', 'E22', 'E23', 'E24', 'E25','E27', 'E28', 'E29'],
  },
];

// TODO: flowb
/* export const defaultTabsFlowB = [
  {
    step: 0,
    title: 'Historial crediticio',
    states: [
      'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7',
      'E10', 'E11', 'E12', 'E13', 'E14',
      'E32', 'E33', 'E34', 'E35', 'E36',
      'E40', 'E41', 'E42', 'E43', 'E44'
    ],
  },
  {
    step: 1,
    title: 'Información complementaria',
    states: [
      'E8', 'E9',
      'E15', 'E16',
      'E37', 'E38',
      'E45', 'E46'
    ],
  },
  {
    step: 2,
    title: 'Carga de documentos',
    states: ['E18','E48'],
  },
  {
    step: 3,
    title: 'Formulario de Solicitud',
    states: ['E20'],
  },
  {
    step: 4,
    title: 'Verificación de identidad',
    states: ['E17', 'E31', 'E39', 'E47' ],
  },
  {
    step: 5,
    title: 'Estatus Final',
    states: ['E21', 'E22', 'E23', 'E24', 'E25', 'E26', 'E27', 'E28', 'E29','E50', 'E49', 'E51'],
  },
]; */
